/* eslint-disable complexity */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import getContentNASingleItem from '@kfc-global/react-shared/redux/Actions/NASingleItemAction';
import { getCmsClient } from 'common/utilities/cmsClient';
import { isMobileDevice, isEmptyObject } from 'common/utilities/utils';
import { NUTRITION_ALLERGEN_GUIDE, KFC_FOOD } from '../NutritionAllergenConstants/NutritionAllergenConstants';
import { CompactNutritionAllergenItem } from '../Presentation/CompactNutritionAllergen';
import { RESIZE, EQUALS, MDMID, EXISTS, NAME } from 'common/constants/SharedConstants';
import { checkItemName } from 'organisms/MenusPLP/AU/MenusPlpUtilities/MenusPlpUtils';
import {
  createSingleItemNodeList,
  getNASingleItemData,
  modifyProdsData,
} from 'organisms/NutritionAllergenLandingPage/AU/NutritionAllergenUtilities/NutritionAllergenUtils';
import get from 'lodash/get';
/* istanbul ignore next */
export const filterByKeyValues = (tempData, key, value, type = EQUALS) => {
  let productArr = [];
  let filteredObjData = tempData?.categories
    .filter(({ isHidden }) => !isHidden)
    .map(obj => {
      let obj1 = obj?.products?.filter(objN => !objN.isHidden && objN[key] === value);
      if (type === EXISTS) {
        if (key === 'name') {
          obj1 = obj.products.filter(
            objN =>
              (!objN.isHidden && objN[key].toLowerCase().indexOf(value) !== -1) || checkItemName(objN[key], value),
          );
        } else {
          obj1 = obj.products.filter(objN => !objN.isHidden && objN[key].toLowerCase().indexOf(value) !== -1);
        }
      }
      if (obj1?.length) {
        obj.products = obj1;
        productArr.push(obj1);
        return obj;
      }
      return false;
    }) /* istanbul ignore next */
    .filter(Boolean);
  return {
    productArr,
    filteredObjData,
  };
};

export const NutritionAllergenComponent = props => {
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { contentData: navigationContentData, selectedCat } = props;
  const { tenantReducer } = navigationContentData;
  const menuReducer = useSelector(data => data.menuReducer) ?? {};
  const prodsData = menuReducer?.data ?? {};
  const updatedProdsData = JSON.parse(JSON.stringify(prodsData));
  const [filteredData, setfilteredData] = useState([]);
  const [productId, setProductId] = useState('');
  const dispatch = useDispatch();
  let naSingleItemData = null;
  const allReducerData = useSelector(data => {
    return {
      naSingleItemContent: get(data, 'naSingleItemReducer.response', null),
    };
  });

  if (isEmptyObject(allReducerData?.naSingleItemContent)) {
    naSingleItemData = getNASingleItemData(allReducerData?.naSingleItemContent);
  }
  let naSingleItemObj = {};
  naSingleItemObj = createSingleItemNodeList(naSingleItemData);
  const modifiedData = modifyProdsData(naSingleItemObj, updatedProdsData);

  const handleFilteredData = mdmId => {
    let tempData = JSON.parse(JSON.stringify(modifiedData));
    let { productArr, filteredObj } = filterByKeyValues(tempData, MDMID, mdmId, EQUALS);
    const tempFilteredData = Object.assign(tempData, {
      menu: [],
      categories: filteredObj,
      products: productArr.flat(),
    });
    setfilteredData(tempFilteredData);
  };

  const handleSearchdata = name => {
    if (name) {
      const tempData = JSON.parse(JSON.stringify(modifiedData));
      let { productArr, filteredObj } = filterByKeyValues(tempData, NAME, name, EXISTS);
      const tempFilteredData = Object.assign(tempData, {
        menu: [],
        categories: filteredObj,
        products: productArr.flat(),
      });
      setfilteredData(tempFilteredData);
    } else {
      setfilteredData({});
    }
  };

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);

  useEffect(() => {
    dispatch(
      getContentNASingleItem({
        object: getCmsClient(),
        contentFull: {
          content_type: 'singleItem',
          include: '5',
        },
      }),
    );
  }, [dispatch]);
  return (
    <React.Fragment>
      <div id='nutration-allergen-guide' className='nutration-and-allergen-guide-section'>
        <div className='nutration-and-allergen-guide-info'>
          <p>{translateWithI18Next(KFC_FOOD)} </p>
          <div className='info'>{translateWithI18Next(NUTRITION_ALLERGEN_GUIDE)}</div>
        </div>
      </div>
      <div className={!isMobile && 'plp-container plp-au-container grid-container'}>
        <CompactNutritionAllergenItem
          {...props}
          tenantData={tenantReducer}
          data={modifiedData}
          handleFilteredData={handleFilteredData}
          handleSearchdata={handleSearchdata}
          tempData={filteredData}
          selectedCat={selectedCat}
          setProductId={setProductId}
          isMobile={isMobile}
        />
      </div>
    </React.Fragment>
  );
};
